<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('BANK_LIST')">
        <slot name="section-bank-list">
          <section-bank-list ref="BANK_LIST"
                             id="BANK_LIST"
                             :extended="isExtended('BANK_LIST')"
                             :showButton="true"
                             :autoSave="true"
                             :readOnly="readOnly"
                             :moduleId="moduleId"
                             :searchText="searchText"
                             :ressourceHeader="ressource"
                             :fiche="fiche"
                             :bank-log=selectedBankLog
                             :route="route"
                             :attribut="attribut"
                             @extended="setExtended"
                             @fullscreen="setFullscreen"
                             @status="updateStatus"
                             @updated="bankLogUpdated"
                             @selectItem = "selectItem">
          </section-bank-list>
        </slot>
    </v-col>
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('BANK_DETAIL')">
        <slot name="section-bank-detail">
          <section-bank-detail ref="BANK_DETAIL"
                               id="BANK_DETAIL"
                               :extended="isExtended('BANK_DETAIL')"
                               :showButton="true"
                               :autoSave="true"
                               :readOnly="readOnly"
                               :moduleId="moduleId"
                               :searchText="searchText"
                               :ressourceHeader="ressource"
                               :fiche="fiche"
                               :bank-log=selectedBankLog
                               :route="route"
                               :attribut="attribut"
                               @extended="setExtended"
                               @fullscreen="setFullscreen"
                               @status="updateStatus"
                               @updated="bankLogUpdated"
                               @selectItem = "selectItem">
          </section-bank-detail>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import BankLog from '@/extend/classes/BankLog';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionBankList from '@/custom/sections/SectionBankList.vue';
import SectionBankDetail from '@/custom/sections/SectionBankDetail.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionBankList,
    SectionBankDetail,
    FicheHeader,
  },

  props: {
    bankLog: {
      type: Object as PropType<BankLog>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.BANQUE,
      sections: [
        'BANK_LIST',
        'BANK_DETAIL',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_BANQUE);
    },

    selectedBankLog (): BankLog {
      return this.bankLog
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    bankLogUpdated (bankLog: BankLog) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.bankLog || this.bankLog.id < 0) && value == 'BANK_LIST') {
        this.setExtended(new Extended('BANK_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
